export var containerCentredStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
};
var CDN_BASE_URL = 'https://smart-links-cdn.us-east-1.prod.public.atl-paas.net';
export var LockImage = CDN_BASE_URL + "/lock.svg";
export var CelebrationImage = CDN_BASE_URL + "/celebration.svg";
//# sourceMappingURL=constants.js.map